// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  accessKey: "53B22BAB-D093-4A66-AD03-C281E8920275",
  // tslint:disable-next-line: max-line-length
  secretKey:
    "4c59ba7665058d6d72828de5f1ca08a79f8994b584a86d2f5811804f6c4dbf0699e3d29f8060b3443689a2962faec65a1304cec0e4bc8334cace4f9ee9a08be5",
  //url: "http://104.211.167.63:5083",
     //url: 'https://sa.holostikapp.com'
  url: location.origin
  //url: "https://sureassure.com"
  //  url:'http:localhost:55966'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
